/**
 * Debug utilities for Alpaca API
 */

import { getConfig } from './config';

/**
 * Use this function to check the exact credentials being sent to Alpaca
 * Call window.checkAlpacaCredentials() in the browser console to debug
 */
export function checkAlpacaCredentials() {
  if (typeof window !== 'undefined') {
    // @ts-ignore
    window.checkAlpacaCredentials = () => {
      const config = getConfig();
      
      console.log('=== ALPACA CREDENTIALS CHECK ===');
      // Only log first/last 4 characters of credentials for security
      console.log(`Key ID: ${maskString(config.keyId)}`);
      console.log(`Secret Key: ${maskString(config.secretKey)}`);
      console.log(`Paper Trading: ${config.paper}`);
      console.log(`API URL: ${config.baseUrl}`);
      console.log(`Data URL: ${config.dataBaseUrl}`);
      console.log('================================');
    };
  }
}

/**
 * Masks sensitive strings for logging
 */
function maskString(str: string): string {
  if (!str) return '[empty]';
  if (str.length <= 8) return '****';
  return str.substring(0, 4) + '****' + str.substring(str.length - 4);
}